//获取localStorage
export function getLocalStorage(name) {
	let value = localStorage.getItem(name);
	if (value !== "undefined") {
		return JSON.parse(value);
	} else {
		return null;
	}
}

//获取当前使用的语言
export function getCurrentLanguage() {
	let name = "tab-lang";
	let language = getLocalStorage(name);
	if (language) {
		return language;
	} else {
		let reg = /^zh-/gi;
		if (navigator.language === "zh" || reg.test(navigator.language)) {
			return "cn";
		} else {
			return "en";
		}
	}
}

// 数字累加
export function numAutoAdd(el, option) {
	let time = 3000;
	// 最终值
	let finalNum = option.num || el.data("value");
	let finalValue = option.value || null;
	//	调速器
	let regulator = option.regulator || 100;
	let step = finalNum / (time / regulator);
	let count = 0;
	let initial = 0;

	let timer = setInterval(function () {
		count = count + step;
		if (count >= finalNum) {
			clearInterval(timer);
			if (finalValue) {
				el.html(finalValue);
			} else {
				el.html(finalNum);
			}
			return;
		}

		//t未发生改变的话就直接返回
		//避免调用text函数，提高DOM性能
		let t = Math.floor(count);
		if (t === initial) {
			return;
		}
		initial = t;
		el.html(initial);
	}, 80);
}

// 获取模糊时间
export function timerFormat(time) {
	var timestamp = new Date(time).getTime();
	var mistiming = Math.round((Date.now() - timestamp) / 1000);
	var arrr = ["年", "个月", "周", "天", "小时", "分钟", "秒"];
	var arrn = [31536000, 2592000, 604800, 86400, 3600, 60, 1];
	for (var i = 0; i < arrn.length; i++) {
		var inm = Math.floor(mistiming / arrn[i]);
		if (inm !== 0) {
			return inm + arrr[i] + "前";
		}
	}
}
